import qs from "qs";

import { QUOTE_STATUS_LABEL_TO_WIRE } from "components/Carrier/components/QuoteStatusMultiSelect/quoteStatusFilterGroups";

import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

interface Props {
  currentPage: number;
  pageSize: number;
  filters: QuoteFilters;
  enabled?: boolean;
}

interface ListCondensedQuotesForCarrierResponse {
  quotes: CondensedQuote[];
  count: number;
}

export function useCarrierQuotes(props: Props) {
  const { currentPage: page, pageSize, filters, enabled = true } = props;
  const limit = pageSize;
  const offset = (page - 1) * limit;

  const getShipmentTypes = () => {
    if (
      filters?.shipmentTypes?.length === 1 &&
      filters.shipmentTypes[0] === "ALL"
    ) {
      return [];
    }
    return filters?.shipmentTypes;
  };

  const buildFilterQueryParameters = () => {
    const expandedQuoteStatus =
      filters?.quoteStatus?.flatMap(
        (label) => QUOTE_STATUS_LABEL_TO_WIRE[label] ?? [],
      ) ?? null;

    const sortBy = filters?.sortBy;

    const filtersObject = {
      quote_status: expandedQuoteStatus?.length ? expandedQuoteStatus : null,
      shipment_name: filters?.shipmentName ?? null,
      shipment_type: getShipmentTypes() ?? null,
      origin_province: filters?.originProvinces ?? null,
      destination_province: filters?.destinationProvinces ?? null,
      pickup_date_after: filters?.pickupDateAfter ?? null,
      pickup_date_before: filters?.pickupDateBefore ?? null,
      delivery_date_after: filters?.deliveryDateAfter ?? null,
      delivery_date_before: filters?.deliveryDateBefore ?? null,
      shipment_status: filters?.shipmentStatus ?? null,
      equipment_type: filters?.equipmentTypes ?? null,
      service_type: filters?.serviceTypes ?? null,
      sort_by: sortBy !== undefined && sortBy !== "" ? sortBy : null,
      offset,
      limit,
    };

    return qs.stringify(filtersObject, {
      skipNulls: true,
      arrayFormat: "repeat",
    });
  };

  const { role } = useRoleContext();

  const url =
    role != null && enabled
      ? `/carriers/${role.id}/quotes?${buildFilterQueryParameters()}`
      : null;

  const { data, loading, error, refetch } =
    useSwrFetch<ListCondensedQuotesForCarrierResponse>({
      url,
      errorMessage: "Failed to fetch quotes",
      errorMessageKey: "message",
    });

  return {
    quotes: data?.quotes ?? null,
    loading,
    error,
    count: data?.count ?? null,
    refetchQuotes: refetch,
  };
}
